import Box from '@mui/material/Box';
import { useHasPermission } from '../../../../contexts/auth';
import { TenantSettingsSection } from '../tenantSettings/tenantSettingsSection.component';
import { TenantNumerationSchemasList } from './tenantNumerationSchemasList.component';

/** The grid fills its container, which on this page has no height of its own. */
const SCHEMAS_GRID_HEIGHT = 480;

/**
 * Numbering settings: which schema each document type defaults to, followed by
 * the catalogue of schemas those defaults are chosen from - the defaults are
 * meaningless without the list, so both live on one page.
 */
export const TenantNumberingSettings = () => {
  const canViewSchemas = useHasPermission('settlement.view_numerationschema');
  const canViewSettings = useHasPermission('config.view_tenantsettings');

  const schemas = canViewSchemas ? (
    <Box sx={{ height: SCHEMAS_GRID_HEIGHT }}>
      <TenantNumerationSchemasList />
    </Box>
  ) : null;

  if (!canViewSettings) {
    return schemas;
  }

  return <TenantSettingsSection section="numbering">{schemas}</TenantSettingsSection>;
};
